import CheckoutOverlay from '../../CheckoutOverlay';
import ModeOverlayLazyLoader from './ModeOverlayLazyLoader';

function ModeOverlay() {
  return (
    <CheckoutOverlay
      popup
      stickyHeader
      nopadding
    >
      <ModeOverlayLazyLoader />
    </CheckoutOverlay>
  );
}

export default ModeOverlay;
